export default __webpack_public_path__ + "static/media/icon-user.331c90fd.webp";